import FrontEndApi from '../../../Common/Globals/Scripts/FrontEndApi';

async function sendAccountRecoveryEmail(userName) {
    return await FrontEndApi.sendAccountRecoveryEmail(userName);
}

export default { sendAccountRecoveryEmail }
